import { Box, BoxProps } from '@chakra-ui/react';
import React from 'react';

export function Filler(props: BoxProps) {
	return <Box flex={1} minW={0} {...props} />;
}
